import React from "react";
import PropTypes from "prop-types";

import "./Loader.scss";

const Loader = ({ active, spinnerOnly, iconClass, size }) => {
	const spinner = (
		<i
			className={`${iconClass} ${spinnerOnly && !active ? "hidden" : ""}${size === "small" ? "small-spinner" : "large-spinner"}`}
		/>
	);
	return (
		<div className="loader-component">
			<Choose>
				<When condition={spinnerOnly}>{spinner}</When>
				<Otherwise>
					<div className={`loader ${active ? "active" : ""}`}>{spinner}</div>
				</Otherwise>
			</Choose>
		</div>
	);
};

Loader.propTypes = {
	active: PropTypes.bool,
	spinnerOnly: PropTypes.bool,
	iconClass: PropTypes.string,
	size: PropTypes.string,
};

Loader.defaultProps = {
	active: false,
	spinnerOnly: false,
	iconClass: "rkf rkf-spinner rkf-spin rkf-fw",
	size: "large",
};

export default Loader;
